import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import BackgroundElements from './background-elements/BackgroundElements';

const HomeScreen = ({ onTakeSurvey, onAllBrandsClick, onReviewClick }) => {
  return (
    <div className={styles.container}>
      <div
        className={styles.content}
        style={{
          backgroundImage: `url(${getImageFromS3('images/26ua-kv3/bg.png')})`
        }}
      >
        <BackgroundElements />
        <img
          className={styles.staticFlower}
          src={getImageFromS3('images/26ua-kv3/static-flower.png')}
          alt="staticFlower"
        />
        <img
          className={styles.logo}
          src={getImageFromS3('images/26ua-kv3/logo.png')}
          alt="logo"
        />
        <img
          className={styles.packs}
          src="/images/26ua-kv3/packs.png"
          alt="packs"
        />
        {/*<div className={styles.buttonContainer}>*/}
        {/*  <button className={styles.reviewButton} onClick={onReviewClick}>*/}
        {/*    <p>Залишити відгук про продукт</p>*/}
        {/*    <img*/}
        {/*      src={getImageFromS3('images/26ua-kv3/glass.png')}*/}
        {/*      alt="glass"*/}
        {/*    />*/}
        {/*  </button>*/}
        {/*  <button className={styles.rangeButton} onClick={onAllBrandsClick}>*/}
        {/*    <p>Повний асортимент</p>*/}
        {/*  </button>*/}
        {/*</div>*/}
        <div className={styles.formatContainer}>
          <h2>Формат</h2>
          <h3>
            100 Super Slims
            <br />
            ("100 супер слімc")
          </h3>
          <img
            src={getImageFromS3('images/26ua-kv3/format.png')}
            alt="format"
          />
        </div>
        <div className={styles.tobaccoContainer}>
          <h2>
            <b>Якісна</b> тютюнова
            <br /> суміш
          </h2>
          <img
            src={getImageFromS3('images/26ua-kv3/tobacco.png')}
            alt="tobacco"
          />
        </div>
        <div className={styles.filterContainer}>
          <h2>
            <b>Класичний</b>
            <br /> ацетатний фільтр
          </h2>
          <h3>з високоякісної целюлози</h3>
          <img
            src={getImageFromS3('images/26ua-kv3/filter.png')}
            alt="filter"
          />
        </div>
        <div className={styles.quizContainer}>
          <div className={styles.quizContent}>
            <h2>Хочеш отримувати новини про продукцію?</h2>
            <h3>
              Проходь невелике опитування та отримуй 30 грн на мобільний за
              витрачений час.
            </h3>
            <button className={styles.quizButton} onClick={onTakeSurvey}>
              <p>Пройти опитування</p>
              <img
                src={getImageFromS3('images/26ua-kv3/quiz-glass.png')}
                alt="quiz-glass"
              />
            </button>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br />
        серйозні
        <br />
        захворювання та
        <br />
        залежність Дана
        <br />
        інформація про
        <br />
        продукт надається
        <br />
        відповідно до статті 15
        <br />
        Закону України «Про
        <br />
        захист прав
        <br />
        споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
